import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'
// import router from '../router'


axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.baseURL = process.env.VUE_APP_API_URL
if(localStorage.getItem('user-token')) {
    const token = localStorage.getItem('user-token')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

axios.interceptors.request.use(request => {
  const token = store.getters['token'];
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  // const locale = store.getters['lang/locale'];
  // if (locale) {
  //   request.headers.common['Accept-Language'] = locale;
  // }
  return request;
})

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('user-token') || '',
    status: '',
    user: {},
    team: {},
    member: {},
    works: {},
    assignees: [],
    team_member_work: [],
    work: null
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    token: state => state.token,
    team: state => state.team,
    members: state => state.team.members || [],
    member: state => state.member,
    works: state => state.works || [],
    team_member_work: state => state.team_member_work || [],
    assignees: state => state.assignees || [],
    work: state => state.work,
  },
  mutations: {
    AUTH_REQUEST: (state) => {
      state.status = 'loading'
    },
    AUTH_SUCCESS: (state, token) => {
      state.status = 'success'
      state.token = token
    },
    AUTH_ERROR: (state) => {
      state.status = 'error'
    },
    USER_REQUEST: state => {
      state.status = "loading";
    },
    USER_SUCCESS: (state, resp) => {
      state.status = "success";
      Vue.set(state, "profile", resp);
    },
    USER_ERROR: state => {
      state.status = "error";
    },
    AUTH_LOGOUT: state => {
      state.profile = {};
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_TEAM: (state, { team }) => {
      state.team = team
    },
    SET_MEMBER: (state, member) => {
      state.member = member
    },
    SET_WORKS: (state, works) => {
      state.works = works
    },
    SET_WORK: (state, work) => {
      state.work = work
    },
    SET_TEAM_MEMBER_WORK: (state, data) => {
      state.team_member_work = data
    },
    SET_ASSIGNEES: (state, assignees) => {
      state.assignees = assignees;
    },
    ADD_MEMBER: (state, user) => {
      state.team.members.push(user)
    },
    UPDATE_MEMBER: (state, user) => {
      if (!state.team.members) return
      for (let i = 0; i < state.team.members.length; i++) {
        let u = state.team.members[i]
        if (u.id == user.id) {
          Vue.set(state.team.members, i, user)
        }
      }
    },
    DELETE_MEMBER: (state, id) => {
      if (state.team.members) {
        for (let i = state.team.members.length - 1; i >= 0; i--) {
          if (state.team.members[i].id == id) {
            state.team.members.splice(i, 1)
          }
        }
      }
      const invited = state.team.invited || []
      for (let i = invited.length - 1; i >= 0; i--) {
        if (invited[i].id == id) {
          invited.splice(i, 1)
        }
      }
    }
  },
  actions: {
    async auth_request({ commit }, user) {
      try {
        commit('AUTH_REQUEST')

        const resp = await axios.post('/oauth/token', user)
        const token = resp.data.access_token

        localStorage.setItem('user-token', token)

        // set token globally
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        const res = await axios.get('/api/v1/user')

        const userData = res.data.data
        const isMarketingEnabled = res.data.marketing;
        const isTeamManager = userData.is_team_lead || (userData.is_marketing_user && isMarketingEnabled)

        if (isTeamManager) {
          commit('AUTH_SUCCESS', token)
          commit('SET_USER', userData)

          localStorage.setItem('user-code', userData.code)
          localStorage.setItem('marketing', res.data.marketing ? "1" : "0")

          if (userData.is_team_lead) {
            localStorage.setItem('user-role', 'team-lead')
          } else if (userData.is_marketing_user) {
            localStorage.setItem('user-role', 'marketing-user')
          }

          return resp
        }

        throw new Error('Unauthorized role')

      } catch (err) {
        commit('AUTH_ERROR', err)

        localStorage.removeItem('user-token')
        localStorage.removeItem('user-role')
        localStorage.removeItem('user-code')
        localStorage.removeItem('marketing')

        throw err
      }
    },
    auth_logout({ commit }) {
      return new Promise((resolve) => {
        commit('AUTH_LOGOUT')
        // console.log('deleting token from')
        localStorage.removeItem('user-token') // clear your user's token from localstorage
        localStorage.removeItem('user-role')
        localStorage.removeItem('user-code')
        resolve()
      })
    },
    async reset_password({ commit }, formData) {
      let res = await axios.post("/api/v1/user/password_reset", formData)
      if (res.status != 200) {
        // console.log("passwort reset error")
        throw 'Error resetting password: ' + res.data.message;
      }
      commit('AUTH_LOGOUT')
    },
    // async getUser({ commit }) {
    //   let res = await axios.get('/api/v1/user')
    //   let isTeamManager = res.data.data.is_team_lead;
    //   if (isTeamManager != undefined && isTeamManager == true) {
    //     console.log('user is teammanger')
    //     commit('SET_USER', res.data.data)
    //   } else {
    //     console.log('user not teammanger. logging out..')
    //     commit('AUTH_LOGOUT')
    //     console.log('deleting token from')
    //     localStorage.removeItem('user-token') // clear your user's token from localstorage
    //     router.push({name: 'login'})
    //   }

    // },
    async getTeam({ commit }, { from, to }) {
      if (from == null) from = moment().startOf('isoWeek').format('YYYY-MM-DD')
      if (to == null) to = moment().endOf('isoWeek').format('YYYY-MM-DD')

      // console.log('from=', from)
      // console.log('to=', to)
      let res = await axios.get('/api/v1/team', {
        params: {
          date_from: from,
          date_to: to
        }
      })
      // console.log('API team: ', res.data.data)
      // console.log('API team_stats: ', res.data.data.stats)

      commit('SET_TEAM', { team: res.data.data })


    },
    async getMember({ commit }, { id, from, to }) {
      const res = await axios.get('/api/v1/team/members/' + id, {
        params: {
          date_from: from,
          date_to: to
        }
      })
      // console.log('API member: ', res.data.data)
      commit('SET_MEMBER', res.data.data)
    },
    async addMember({ commit }, user) {
      let u = {
        team_id: this.state.team.id,
        name: user.first_name + ' ' + user.last_name,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email
      }
      const res = await axios.post('/api/v1/team/members/add', u)
      if (res.data.status !== 'success') {
        const msg = res.data.message || 'Mitglied konnte nicht hinzugefügt werden'
        throw new Error(msg)
      }
      // Eingeladene Nutzer stehen auf dem Server unter invited (status 0), nicht in members — Liste per getTeam aktualisieren
    },
    async updateMember({ commit }, user) {
      // console.log('update user=', JSON.stringify(user))
      const res = await axios.put('/api/v1/team/members/' + user.id, user)
      commit('UPDATE_MEMBER', res.data.data)
    },
    async deleteMember({ commit }, {id, successor_id}) {
      // console.log('delete user=', JSON.stringify(id))
      await axios.delete('/api/v1/team/members/' + id + '?successor_id=' + successor_id)
      // console.log('API members delete', { res })
      commit('DELETE_MEMBER', id)
    },
    async getWorks({ commit }, payload = 1) {
      let page = 1
      let rpp
      if (typeof payload === 'object' && payload !== null && !Array.isArray(payload)) {
        page = payload.page != null ? Number(payload.page) || 1 : 1
        rpp = payload.rpp
      } else {
        page = Number(payload) || 1
      }
      let url = '/api/v1/marketing/team/work?page=' + page
      if (rpp != null && rpp !== '') {
        url += '&rpp=' + encodeURIComponent(String(rpp))
      }
      const res = await axios.get(url, {})
      commit('SET_WORKS', res.data.data)
    },
    async getWork({ commit }, {id}) {
      const res = await axios.get('/api/v1/marketing/team/work/' + id, {
      })
      commit('SET_WORK', res.data.data)
      commit('SET_ASSIGNEES', res.data.assignees)
    },
    async getTeamMemberWork({ commit }) {
      const res = await axios.get('/api/v1/marketing/team/members', {
      })
      commit('SET_TEAM_MEMBER_WORK', res.data.members)
    },
    async marketingAssignWork({ commit }, { user_ids, work_id, position }) {
      const res = await axios.post(`/api/v1/marketing/assign`, { user_ids: user_ids, work_id: work_id, position: position  }, { })
      return res;
    },
    async marketingUnassignWork({ commit }, { work_id, user_id }) {
      const res = await axios.get(`/api/v1/marketing/unassign/${work_id}/${user_id}`, { })
      return res;
    },
    async marketingUnassignAllWork({ commit }, { user_ids }) {
      const res = await axios.post(`/api/v1/marketing/unassign-all`, {user_ids: user_ids}, { })
      return res;
    },
    //
    async saveWork({ commit }, { id, payload }) {
      const res = await axios.put('/api/v1/marketing-works/' + id, payload, {
      })
      return res;
    },
    async createWork({ commit }, { payload }) {
      const res = await axios.post('/api/v1/works', payload, {
      })
      return res;
    },
    async deleteWork({ commit }, { id }) {
      const res = await axios.delete('/api/v1/works/' + id, {
      })
      return res;
    },
    async saveWorkImage({ commit }, { id, formData }) {
      const res = await axios.post(
          '/api/v1/marketing-works/' + id + '/image',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      );
    },
    async assignWork({ commit }, { work_id, user_id }) {
      const res = await axios.get(`/api/v1/works/assign/${work_id}/${user_id}`, {
      })
      return res;
    },
    async getToken({ commit }) {
      const res = await axios.get('/api/v1/token/get')
      return res;
    },
    async sendPush({ commit }, data) {
      // console.log({ data })
      // console.log('sending message ' + data.message + ' to users: ' + data.users)
      let user_ids = []
      for (let i = 0; i < data.users.length; i++) {
        user_ids.push(data.users[i].id)
      }

      await axios.post('/api/v1/team/notifications', { users: user_ids, message: data.message })
      commit('SUCCESS_PUSH')
    }
  }
})

export default store
// export default {state, actions, getters, mutations}